<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-wallet" />
            {{ $t('wallets') }}
        </template>
        <WalletsTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@src/partials/pages/PageWrapper.vue'
import WalletsTable from '@src/partials/wallets/WalletsTable.vue'
</script>
